<template>
  <div id="settingsCatering">
    <Tabs>

      <TabSection :title="$t('settings.general')" v-if="config.catering" class="general">
        <div class="columns">
          <div class="column">
            <div class="group">
              <label>{{ $t("settings.delay") }}</label>
              <input type="number" v-model="config.catering.general.averageDelay">
            </div>
            <div class="group">
              <label>{{ $t('settings.disable_today') }}</label>
              <select v-model="config.catering.inAdvance.todayDisabled">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="group" v-if="permissions.tipsActivated">
              <div class="subtitle">{{ $t('settings.tip') }}</div>
              <TipBox no-border info>
                <span v-html="$t('tips.tip')"></span>
              </TipBox>
              <label>{{ $t("settings.tip") }}</label>
              <select v-model="config.catering.general.tipsActivated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
          </div>
          <div class="column">
            <div class="subtitle">
              <span class="flex-grow">{{ $t("settings.service_fee") }}</span>
            </div>
            <TipBox info no-border>
              <span v-html="$t('tips.service_fees')"></span>
            </TipBox>
            <div class="group">
              <label>{{ $t("settings.amount") }} ({{ currencySymbol }})</label>
              <input type="number" v-model="config.catering.general.serviceFees.amount">
            </div>
            <div class="subtitle">
              <span class="flex-grow">{{ $t("settings.order_amount") }}</span>
            </div>
            <TipBox danger no-border>
              <span v-html="$t('tips.minimum_amount')"></span>
            </TipBox>
            <div class="columns">
              <div class="column group">
                <label>{{ $t("settings.minimum_amount") }} ({{ currencySymbol }})</label>
                <input type="number" v-model="config.catering.general.minimumPrice">
              </div>
              <!--<div class="column group">
                <label>{{$t("settings.maximum_amount")}} ({{currencySymbol}})</label>
                <input type="number" v-model="config.catering.general.maximumPrice">
              </div>-->
            </div>
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('open_hours')" v-if="cascader && config.catering">
        <TipsOpenHours />
        <div id="editOpenHoursContainerCatering" class="group">
          <input id="editOpenHoursCatering" type="checkbox" v-model="config.catering.editOpenHours">
          <label for="editOpenHoursCatering">{{ $t("settings.edit_open_hours") }}</label>
        </div>
        <div class="columns" :class="{ openHoursDisabled: !config.catering.editOpenHours }">
          <div class="column">
            <DayTimeRange :day="cascader.get('catering.hours.monday').value" dayName="monday" context="catering" />
            <DayTimeRange :day="cascader.get('catering.hours.tuesday').value" dayName="tuesday" context="catering" />
            <DayTimeRange :day="cascader.get('catering.hours.wednesday').value" dayName="wednesday" context="catering" />
            <DayTimeRange :day="cascader.get('catering.hours.thursday').value" dayName="thursday" context="catering" />
          </div>
          <div class="column">
            <DayTimeRange :day="cascader.get('catering.hours.friday').value" dayName="friday" context="catering" />
            <DayTimeRange :day="cascader.get('catering.hours.saturday').value" dayName="saturday" context="catering" />
            <DayTimeRange :day="cascader.get('catering.hours.sunday').value" dayName="sunday" context="catering" />
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('message')" v-if="config.catering">
        <div class="group">
          <label>{{ $t("settings.service_message") }}</label>
          <textarea v-model="config.catering.onEnterMessage.fr" />
        </div>
      </TabSection>

      <TabSection :title="$t('notifications')" v-if="config.catering">
        <TipsNotification />
        <div class="subtitle">
          <span class="flex-grow">{{ $t("settings.on_sale_notification") }}</span>
        </div>
        <TipBox warning v-if="!isSMSactivated" no-border>
          <div v-html="$t('tips.sms_feature.disabled')"></div>
        </TipBox>
        <div class="group" :class="{ locked: !isSMSactivated }">
          <label>{{ $t("settings.sms_notification") }}</label>
          <VueSelect multiple v-model="config.catering.notifications.onSale.sms" taggable>
            <span slot="no-options">{{ $t("settings.sms_tip") }}</span>
          </VueSelect>
        </div>
        <div class="group">
          <label>{{ $t("settings.email_notification") }}</label>
          <VueSelect multiple v-model="config.catering.notifications.onSale.emails" taggable>
            <span slot="no-options">{{ $t("settings.email_tip") }}</span>
          </VueSelect>
        </div>
      </TabSection>

      <TabSection :title="$t('settings.questions')">
        <template v-for="(question, qIndex) of config.catering.questions">
          <div class="subtitle">
            <span class="flex-grow">{{ $t("settings.question") + ' #' + (qIndex + 1) }}</span>
          </div>
          <LocalizedInput :translate="question" />
          <div class="question-options">
            <div class="group">
              <input :id="`cat_q_opt_${qIndex}`" type="checkbox" v-model="question.optional">
              <label :for="`cat_q_opt_${qIndex}`">{{ $t("optional") }}</label>
            </div>
            <button class="btn btn-primary" @click="removeQuestion(qIndex)">X</button>
          </div>
        </template>
        <button class="btn btnAddQuestion btn-primary" @click="addQuestion">
          {{ $t('settings.add_question') }}
          <svgicon src="/icon/add.svg" height="15" width="15"></svgicon>
        </button>
      </TabSection>

    </Tabs>

    <div class="footer-actions" v-if="$store.getters.loggedUserHasModifyPermission">
      <button class="btn btn-primary" @click="$emit('save')">{{ $t("save") }}</button>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue';
  import Cascader from "@/resources/cascader";
  import DayTimeRange from '@/components/tools/DayTimeRange.vue';
  import VueSelect from 'vue-select';
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import TipsNotification from "@/components/tips/TipsNotification.vue";
  import TipsOpenHours from "@/components/tips/TipsOpenHours.vue";

  export default {
    name: "SettingsCatering",

    props: {
      config: Object,
      parentConfig: Object,
      permissions: Object,
      currencySymbol: {
        type: String,
        default: '$'
      }
    },

    components: { VueSelect, DayTimeRange, LocalizedInput, TipsNotification, TipsOpenHours },

    async mounted() {
      this.cascader = new Cascader(this.config, this.parentConfig);
    },

    data() {
      return {
        cascader: null
      }
    },

    computed: {
      isSMSactivated() {
        return this.$store.state.contextCompany && this.$store.state.contextCompany.smsActivated;
      }
    },

    watch: {
      "config.catering.editOpenHours": function (edit, old) {
        if (old === undefined) {
          return;
        }
        if (edit) {
          Vue.set(this.config.catering, "hours", this._copy(this.parentConfig.catering.hours));
        } else {
          Vue.delete(this.config.catering, "hours");
        }
        this.$forceUpdate();
      }
    },

    methods: {
      _copy(obj) {
        return JSON.parse(JSON.stringify(obj));
      },
      addQuestion() {
        this.config.catering.questions.push({
          fr: null,
          en: null,
          optional: false
        })
      },
      removeQuestion(index) {
        this.config.catering.questions.splice(index, 1)
      }
    }

  }
</script>

<style lang="scss" scoped>
  #settingsCatering {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .general {
    .subtitle {
      padding-top: 10px;
    }
  }

  #editOpenHoursContainerCatering,
  #activateInAdvanceContainerCatering {
    label {
      color: #404040;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .openHoursDisabled {
    opacity: 0.7;
    pointer-events: none;
  }

  input {
    width: 100%;
  }

  .question-options {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }

  .btnAddQuestion {
    display: flex;
    align-items: center;
    fill: white;

    .svgicon {
      margin-left: 10px;
    }
  }
</style>